<template>
  <div class="condition-number condition-form-item">
    <el-divider />

    <p class="input-label">{{ config.name }}：</p>
    <el-select
      v-model="numberData.compareType"
      size="medium"
      :style="{'width':numberData.compareType !== 'among' ? '180px' : '278px'}"
    >
      <el-option v-for="item in operations" :key="item.code" :label="item.name" :value="item.code"></el-option>
    </el-select>
    <el-input-number
      v-model="numberData.compareValue"
      controls-position="right"
      class="input-number"
      v-if="numberData.compareType !== 'among'"
      :precision="2"
      :min="0.01"
      size="medium"
    ></el-input-number>

    <div v-else class="among">
      <el-input-number
        v-model="numberData.leftRangeValue"
        class="input-number"
        :precision="2"
        :min="0.01"
        size="medium"
        controls-position="right"
      ></el-input-number>
      <el-select v-model="numberData.leftRangeType" style="width:80px;" size="medium">
        <el-option label=" < " value="<"></el-option>
        <el-option label=" ≤ " value="<="></el-option>
      </el-select>

      <p class="among-laber">{{ config.name }}</p>

      <el-select v-model="numberData.rightRangeType" size="medium" style="width:80px;">
        <el-option label=" < " value="<"></el-option>
        <el-option label=" ≤ " value="<="></el-option>
      </el-select>
      <el-input-number
        v-model="numberData.rightRangeValue"
        class="input-number"
        :min="0.01"
        size="medium"
        :precision="2"
        controls-position="right"
      ></el-input-number>
    </div>
  </div>
</template>

<script>
const operations = [
  {
    code: "<",
    name: "小于"
  },
  {
    code: "<=",
    name: "小于等于"
  },
  {
    code: ">",
    name: "大于"
  },
  {
    code: ">=",
    name: "大于等于"
  },
  {
    code: "==",
    name: "等于"
  },
  {
    code: "among",
    name: "介于两者之间"
  }
];

export default {
  props: {
    config: {
      type: Object
    }
  },

  computed: {
    validate() {
      if (this.numberData.compareType === "among") {
        return this.numberData.rightRangeValue > this.numberData.leftRangeValue
          ? true
          : false;
      } else {
        return true;
      }
    }
  },

  data() {
    return {
      numberData: {
        compareType: "<",
        compareValue: 0.01,
        rightRangeValue: 0.02,
        rightRangeType: "<",
        leftRangeType: "<",
        leftRangeValue: 0.01
      },
      operations: operations
    };
  }
};
</script>

<style scoped lang="scss">
@import "../common.scss";
.input-label {
  display: inline-block;
  width: 100px;
  @include ellipsis;
  line-height: 12px;
}

.input-number {
  // height: 36px;
  width: 120px;
  // vertical-align: top;
}

.among {
  margin-top: 20px;
}

.input-number {
  ::v-deep .el-input-number__decrease,
  ::v-deep .el-input-number__increase {
    width: 22px !important;
  }

  ::v-deep .el-input__inner {
    padding-left: 5px;
    padding-right: 23px;
  }
}

.among-laber {
  display: inline-block;
  width: 50px;
  @include ellipsis;
  line-height: 14px;
}

.among > .input-number {
  width: 85px;
}
</style>
